<template>
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">
                <div class="card">
                    <div class="p-3 pb-0 card-header">
                        <div class="d-flex flex-column flex-md-row justify-content-between align-items-center">
                            <div>
                                <h6 class="mb-2 ms-2">Actividades</h6>
                            </div>
                            <div>
                                <input type="text" class="form-control" placeholder="Buscar Actividad..."
                                    v-model="searchQuery">
                            </div>
                            <div>
                                <button class="btn btn-warning mb-0"
                                    @click="openModal({}, 'CreateActivity', 'Crear Actividad')">
                                    <i class="bi bi-plus"></i> Agregar Actividad
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="table-responsive">
                            <table class="table table-bordered">
                                <thead class="text-center">
                                    <th>Actividad</th>
                                    <th>Descripción</th>
                                    <th>¿Es Facturable?</th>
                                    <th>¿Activa?</th>
                                    <th>Acciones</th>
                                </thead>
                                <tbody class="text-center">
                                    <tr v-for="(a, idx) in filteredActivities" :key="idx" class="align-middle">
                                        <td>{{ a.activity }}</td>
                                        <td>{{ a.description }}</td>
                                        <td>
                                            <span :class="{
                                                'badge bg-warning': a.is_billable === true,
                                                'badge bg-secondary': a.is_billable === false
                                            }">
                                                <span v-if="a.is_billable">SI</span><span v-else>NO</span>
                                            </span>
                                        </td>
                                        <td>
                                            <span :class="{
                                                'badge bg-success': a.active === true,
                                                'badge bg-danger': a.active === false
                                            }">
                                                <span v-if="a.active">SI</span><span v-else>NO</span>
                                            </span>
                                        </td>
                                        <td>
                                            <button @click="updateActivityStatus(a.activity_id, a.active)" :class="{
                                                'btn btn-danger mb-0': a.active === false,
                                                'btn btn-success mb-0': a.active == true
                                            }">
                                                <i class="bi bi-power"></i>
                                            </button>
                                            <button class="btn btn-warning mb-0 ms-3"
                                                @click="openModal({ id: a.activity_id }, 'EditActivity', 'Editar Actividad')">
                                                <i class="bi bi-pencil"></i>
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <Modal :isOpen="isModalOpen" :title="modalTitle" :selectedFormComponent="selectedFormComponent"
        :selectedData="selectedData" @close="closeModal" />
</template>
<script setup>

import { ref, onMounted, computed, shallowRef } from "vue"
import axios from 'axios';
const token = localStorage.getItem('authToken'); // Obtén el token del localStorage
const API_BASE_URL = process.env.VUE_APP_BASE_URL;
import Modal from "./components/Modal.vue";
import CreateActivity from "./components/forms/CreateActivity.vue";
import EditActivity from "./components/forms/EditActivity.vue";

const formComponents = {
    CreateActivity: CreateActivity,
    EditActivity: EditActivity
}

const isModalOpen = ref(false);
const selectedFormComponent = shallowRef(null);
const modalTitle = ref("");
const selectedData = ref(null)

// Función para abrir el modal con un formulario y datos específicos
const openModal = (data, formType, title) => {
    selectedData.value = data || {}; // Si no se pasa nada, se inicializa como objeto vacío
    selectedFormComponent.value = formComponents[formType] || null;
    modalTitle.value = title
    isModalOpen.value = true;
};

const closeModal = () => {
    isModalOpen.value = false;
};

const activities = ref([])

const searchQuery = ref("")

// Busqueda y paginación
const filteredActivities = computed(() => {
    const query = searchQuery.value.toLowerCase();
    return activities.value.filter(a =>
        (a.activity?.toLowerCase().includes(query) || a.description?.toLowerCase().includes(query))
    );
});

const getActivities = async () => {

    try {
        const response = await axios.get(`${API_BASE_URL}/all-activities`, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {

            activities.value = response.data

        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }
}

const updateActivityStatus = async (activityId, status) => {

    const body = {
        activity_id: activityId,
        active: status
    }

    try {
        const response = await axios.post(`${API_BASE_URL}/update-activity-status`, body, {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.status === 200) {

            alert(response.data.msg)
            await getActivities()

        } else {
            console.error('Error al obtener los datos');
        }
    } catch (error) {
        console.error('Error en la solicitud:', error);
    }

}


onMounted(
    async () => {
        await getActivities()
    }
)

</script>